import { useRef, useState } from "react";
import { SearchIcon } from "./commonIcons";

const FilterBar = ({ onSearch, fields, defaultOrder, defaultField }) => {
    const [keyword, setKeyword] = useState("");
    const [orderField, setOrderField] = useState(defaultField ? defaultField : "");
    const [orderDir, setOrderDir] = useState(defaultOrder ? defaultOrder : "desc");
    const [focused, setFocused] = useState(false);
    const debounceRef = useRef(null);

    const handleSearch = (e) => {
        const val = e.target.value;
        setKeyword(val);
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            onSearch?.({ keyword: val, orderField, orderDir });
        }, 500);
    };

    const handleField = (e) => {
        const val = e.target.value;
        setOrderField(val);
        onSearch?.({ keyword, orderField: val, orderDir });
    };

    const handleDir = () => {
        const val = orderDir === "asc" ? "desc" : "asc";
        setOrderDir(val);
        onSearch?.({ keyword, orderField, orderDir: val });
    };



    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&display=swap');

                .fb-root * {
                    box-sizing: border-box;
                    font-family: 'DM Sans', sans-serif;
                }

                .fb-root {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    gap: 8px;
                    width: 100%;
                    padding: 4px 0;
                }

                .fb-select-wrap {
                    position: relative;
                    display: flex;
                    align-items: center;
                    height: 38px;
                    background: #ffffff;
                    border: 1.5px solid #e8eaf0;
                    border-radius: 10px;
                    padding: 0 10px 0 12px;
                    gap: 6px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 0 0 0 rgba(99,102,241,0);
                    transition: border-color 0.2s, box-shadow 0.2s;
                    cursor: pointer;
                }

                .fb-select-wrap:hover,
                .fb-select-wrap:focus-within {
                    border-color: #a5b4fc;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 0 0 3px rgba(99,102,241,0.12);
                }

                .fb-label {
                    font-size: 10px;
                    font-weight: 600;
                    letter-spacing: 0.07em;
                    text-transform: uppercase;
                    color: #9ca3af;
                    white-space: nowrap;
                    user-select: none;
                }

                .fb-select {
                    border: none;
                    outline: none;
                    font-size: 13.5px;
                    font-weight: 500;
                    color: #1e1f2e;
                    background: transparent;
                    cursor: pointer;
                    padding-right: 20px;
                    appearance: none;
                    -webkit-appearance: none;
                }

                .fb-chevron {
                    position: absolute;
                    right: 10px;
                    pointer-events: none;
                    color: #9ca3af;
                    display: flex;
                    align-items: center;
                }

                .fb-dir-btn {
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    height: 38px;
                    padding: 0 13px;
                    background: #ffffff;
                    border: 1.5px solid #e8eaf0;
                    border-radius: 10px;
                    font-size: 13px;
                    font-weight: 600;
                    color: #1e1f2e;
                    cursor: pointer;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
                    transition: border-color 0.2s, box-shadow 0.2s, background 0.15s;
                    white-space: nowrap;
                    letter-spacing: 0.01em;
                }

                .fb-dir-btn:hover {
                    border-color: #a5b4fc;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 0 0 3px rgba(99,102,241,0.12);
                    background: #fafafe;
                }

                .fb-dir-icon {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 18px;
                    height: 18px;
                    background: #eef2ff;
                    border-radius: 4px;
                    font-size: 11px;
                    transition: transform 0.25s cubic-bezier(.34,1.56,.64,1);
                }

                .fb-dir-icon.asc {
                    transform: rotate(180deg);
                }

                .fb-search-wrap {
                    display: flex;
                    align-items: center;
                    height: 38px;
                    background: #ffffff;
                    border: 1.5px solid #e8eaf0;
                    border-radius: 10px;
                    padding: 0 12px;
                    gap: 8px;
                    min-width: 200px;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 0 0 0 rgba(99,102,241,0);
                    transition: border-color 0.2s, box-shadow 0.2s, min-width 0.3s cubic-bezier(.4,0,.2,1);
                }

                .fb-search-wrap.focused {
                    border-color: #a5b4fc;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 0 0 3px rgba(99,102,241,0.12);
                    min-width: 240px;
                }

                .fb-search-icon {
                    color: #9ca3af;
                    flex-shrink: 0;
                    transition: color 0.2s;
                    display: flex;
                    align-items: center;
                }

                .fb-search-wrap.focused .fb-search-icon {
                    color: #6366f1;
                }

                .fb-input {
                    border: none;
                    outline: none;
                    font-size: 13.5px;
                    font-weight: 400;
                    color: #1e1f2e;
                    background: transparent;
                    width: 100%;
                    font-family: 'DM Sans', sans-serif;
                }

                .fb-input::placeholder {
                    color: #b0b7c3;
                }

                .fb-divider {
                    width: 1px;
                    height: 18px;
                    background: #e8eaf0;
                    flex-shrink: 0;
                }
            `}</style>

            <div className="fb-root">
                {/* SORT BY */}
                <div className="fb-select-wrap">
                    <span className="fb-label">Sort</span>
                    <div className="fb-divider" />
                    <select value={orderField} onChange={handleField} className="fb-select">
                        {fields?.map((f, i) =>
                            f.enableSorting && (
                                <option key={i} value={f.value}>{f.label}</option>
                            )
                        )}
                    </select>
                    <span className="fb-chevron">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span>
                </div>

                {/* ORDER TOGGLE */}
                <button className="fb-dir-btn" onClick={handleDir} type="button">
                    <span className={`fb-dir-icon ${orderDir}`}>
                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
                            <path d="M5.5 9V2M5.5 2L2.5 5M5.5 2L8.5 5" stroke="#6366f1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span>
                    {orderDir === "asc" ? "Ascending" : "Descending"}
                </button>

                {/* SEARCH */}
                <div className={`fb-search-wrap ${focused ? "focused" : ""}`}>
                    <span className="fb-search-icon">
                        {/* <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <circle cx="6" cy="6" r="4.5" stroke="currentColor" strokeWidth="1.5" />
                            <path d="M9.5 9.5L12 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                        </svg> */}
                        <SearchIcon className="ms-1" size={14} />
                    </span>
                    <input
                        type="text"
                        value={keyword}
                        onChange={handleSearch}
                        placeholder="Search..."
                        className="fb-input"
                        onFocus={() => setFocused(true)}
                        onBlur={() => setFocused(false)}
                    />
                    {keyword && (
                        <span
                            style={{ cursor: "pointer", color: "#9ca3af", display: "flex", alignItems: "center" }}
                            onClick={() => {
                                setKeyword("");
                                onSearch?.({ keyword: "", orderField, orderDir });
                            }}
                        >
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M2 2L10 10M10 2L2 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                            </svg>
                        </span>
                    )}
                </div>
            </div>
        </>
    );
};

export default FilterBar;